// extracted by mini-css-extract-plugin
export default {"root":"UserData_root__HOHz6","avatarIcon":"UserData_avatarIcon__+RNUr"};